export const filterToAllowedAttachmentTypes = <TFileType extends string>(
	types: readonly TFileType[],
	availableTypes: readonly TFileType[],
): TFileType[] => {
	const allowedTypes = new Set(availableTypes);
	return types.filter((type) => allowedTypes.has(type));
};
